/* eslint-disable react/display-name */
import React from 'react';
import { VERSION } from '../Constants';
import { colors } from '../Themes/Colors';
import { image } from '../Themes/Images';

export default () => (
  <div
    style={{
      display: 'flex',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: colors.white,
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <img
        src={image.logo}
        style={{
          width: '50%',
          marginBottom: '20px',
          height: 'auto',
          animation: 'cresce-diminui 1s linear infinite',
        }}
        alt="logomarca-qd"
      />
      <div style={{ color: colors.brand10, fontSize: '1em' }}>{VERSION}</div>
    </div>
  </div>
);
